import { BaseWidgetEditorComponent } from '@juvare/widget-ui/BaseWidgetEditorComponent';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import { Alert } from '@mui/material';
import React from 'react';
import { buildGeneralTab, buildHiddenTab, buildStyleTab, showWidgetEditDialog } from '../WidgetEditDialog';
import { defaultWidgetLabelProvider, makeNewConfigUnique } from '../WidgetForm/Utils';
import { WidgetHandler } from '../WidgetHandler';
import { type } from './types';
const WidgetFormErrors = (props) => {
    var _a;
    const errors = (_a = props.internalData.value) !== null && _a !== void 0 ? _a : [];
    return (React.createElement(Alert, { severity: 'error' },
        React.createElement("div", { "data-test": 'error-messages' }, errors.map(({ id, message }) => (React.createElement("div", { key: id }, message))))));
};
const WidgetFormErrorsEditor = (props) => {
    return (React.createElement(BaseWidgetEditorComponent, Object.assign({}, props, { widgetLabelProvider: defaultWidgetLabelProvider, onEditWidget: (endEditing) => showWidgetEditDialog(props, endEditing, {
            title: 'Errors',
        }, buildGeneralTab(props, {
            children: [
                {
                    type: 'form.text',
                    key: 'component',
                    label: 'Component',
                    validate: {
                        required: true,
                        custom: (value) => {
                            if (value && !new WidgetHandler(props).select(value)) {
                                return 'Component not found';
                            }
                            return undefined;
                        },
                    },
                },
            ],
        }), buildHiddenTab(props), buildStyleTab(props)) }),
        React.createElement(WidgetFormErrors, Object.assign({}, props))));
};
export const widgetFormErrors = {
    type,
    init: (props) => {
        var _a, _b;
        const errors = (_b = (_a = new WidgetHandler(props).select(props.config.component)) === null || _a === void 0 ? void 0 : _a.getVisibleErrorMessages()) !== null && _b !== void 0 ? _b : [];
        props.internalData.value = errors;
        props.hidden = errors.length === 0;
    },
    update: (props) => {
        var _a, _b;
        const errors = (_b = (_a = new WidgetHandler(props).select(props.config.component)) === null || _a === void 0 ? void 0 : _a.getVisibleErrorMessages()) !== null && _b !== void 0 ? _b : [];
        props.internalData.value = errors;
        if (errors.length > 0 && props.hidden) {
            props.hidden = false;
        }
        else if (errors.length === 0 && !props.hidden) {
            props.hidden = true;
        }
        return true;
    },
    component: WidgetFormErrors,
    icon: React.createElement(PriorityHighIcon, { fontSize: 'small' }),
    editorComponent: WidgetFormErrorsEditor,
    createWidget: (rootConfig, editorPath, widgets) => makeNewConfigUnique(rootConfig, editorPath, widgets, { type, key: 'errors', component: '^' }),
};
